<script>
    export let userRef;
    export let registerData;
    userRef.set({
        firstName: registerData.firstName,
        lastName: registerData.lastName,
        street: registerData.street,
        email: registerData.email,
        zip: registerData.zip,
        city: registerData.city
    });
</script>
<h1>fallback: ERROR!!</h1>
